import {
	DatePipe,
	DecimalPipe,
	HashLocationStrategy,
	LocationStrategy,
	registerLocaleData,
	TitleCasePipe,
} from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { SmarteraAuraPreset } from './theme/smartera-aura-preset';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import localeTr from '@angular/common/locales/tr';
import {
	AutoComplateService,
	ErrorHandlerService,
	GlobalErrorHandler,
	Oauth2Service,
	PrintTemplateService,
	UserService,
} from '@api/services';
import { DocumentService } from '@api/services/document.service';

import {
	httpErrorInterceptor,
	httpLogInterceptor,
	httpTokenInterceptor,
	LOCAL_STORAGE_PROTECTED_KEYS,
	SESSION_STORAGE_SYNC_SKIP_KEYS,
	StorageKeys,
} from '@smartera/core';
import { provideLogger } from 'ngx-logging-kit';
import { environment } from 'src/environments/environment';
import { IMAGE_SERVICE } from '@smartera/pipes';
import { LoginDialogService } from '@core/services/login-dialog.service';
import { ThemeColorService } from '@core/services/theme-color.service';
import { ThemeService } from '@core/services';
import { PageModule } from '@feature/page/page.module';
import { LoginModule } from '@modules/login/login.module';
import { MaskPipe, NgxMaskModule } from '@modules/ngx-mask';
import { PrimengModule } from '@modules/primeng/primeng.module';
import { RoundUpPipe } from '@modules/pipes/pipes-items/round-up.pipe';
import { RegistrationModule } from '@modules/registration/registration.module';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoaderModule } from '@shared/components';
import { ConfirmationService, MessageService } from 'primeng/api';
import { routes } from './app.routes';
import { SmartyCubeStorageKeys } from '@core/config';

registerLocaleData(localeTr, 'tr');

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withPreloading(PreloadAllModules)),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideAnimations(),
		providePrimeNG({
			theme: {
				preset: SmarteraAuraPreset,
				options: {
					prefix: 'p',
					darkModeSelector: false,
					cssLayer: false,
				},
			},
		}),
		provideHttpClient(
			withInterceptors([httpTokenInterceptor, httpErrorInterceptor, httpLogInterceptor]),
			withInterceptorsFromDi()
		),
		provideLogger(environment.loggerConfig),
		provideTranslateService({
			loader: provideTranslateHttpLoader({
				// useHttpBackend: interceptor zincirini atlar (ErrorHandlerService ↔ TranslateService döngüsünü önler)
				prefix: 'assets/i18n/',
				suffix: '.json',
				useHttpBackend: true,
			}),
			fallbackLang: 'tr',
		}),
		importProvidersFrom(
			LoginModule,
			RegistrationModule,
			PageModule,
			LoaderModule,
			PrimengModule,
			NgxMaskModule.forRoot()
		),
		MessageService,
		Oauth2Service,
		ConfirmationService,
		{ provide: ErrorHandler, useClass: GlobalErrorHandler },
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: IMAGE_SERVICE, useExisting: DocumentService },
		{
			provide: LOCAL_STORAGE_PROTECTED_KEYS,
			useValue: [
				SmartyCubeStorageKeys.DEMO_USER_DASHBOARD,
				SmartyCubeStorageKeys.DEMO_USER_REPORT_META_DATA,
				SmartyCubeStorageKeys.DEMO_USER_REPORT_GENERAL_SETTINGS,
				SmartyCubeStorageKeys.USERS_SHOWN_INTERACTIVE_DEMO,
				SmartyCubeStorageKeys.THEME,
				SmartyCubeStorageKeys.DATA_GRID_PAGE_NUM,
			],
		},
		{
			provide: SESSION_STORAGE_SYNC_SKIP_KEYS,
			useValue: [StorageKeys.TAB_HASH],
		},
		AutoComplateService,
		PrintTemplateService,
		ThemeColorService,
		ThemeService,
		LoginDialogService,
		MaskPipe,
		DatePipe,
		TitleCasePipe,
		RoundUpPipe,
		DecimalPipe,
		UserService,
	],
};
